module.exports = __webpack_public_path__ + "assets/CircleCenterDetailed.1888c58f35a46ae5442180e8540e7c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleCenterDetailed.png
// module id = 483
// module chunks = 0